export default class AchievementsContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "Achievements";
  }

  show(path) {
    const app = this.app;
    const pageId = this.pageId;

    let model = this.getModel()
    app.populate(pageId, model);
    app.swapPage(pageId);

  }
  getModel() {
    const app = this.app;

    let achivements = [];
    //generate achievement list
    var allAachievements = app.achievements.allAchievements;
    var usersAchievements = app.userdata.achievements || [];

    for (var i = 0; i < allAachievements.length; i++) {
      let achievement = allAachievements[i];
      //check if user has achievement
      let hasAchievement = (usersAchievements.indexOf(achievement.name) !== -1);
      achivements.push({
        title: achievement.title,
        description: achievement.description,
        image: achievement.image,
        owned: hasAchievement,
        locked: !hasAchievement && !achievement.hidden,
        points: Number(achievement.points) || 0
      });
    }
    let total = achivements.reduce(function (acc, c) { return acc + c.points }, 0);
    let earned = achivements.reduce(function (acc, c) {
      return acc + (c.owned ? c.points : 0)
    }, 0);
    let model = {
      achievements: achivements,
      earned: earned,
      total: total
    };
    return model;
  }

}